import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

const Updates = () => {
  const data = [
    {
      id: 1,
      title: "Until Everyone is well.",
      description: "Your health is our priority.",
      icon: "ri-drive-fill",
      color: "text-success",
    },
    {
      id: 2,
      title: "We are totally committed",
      description: "To your health & Wellbeing.",
      icon: "ri-drive-fill",
      color: "text-success",
    },
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade-out
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % data.length); // Switch item
        setFade(true); // Start fade-in
      }, 500); // Duration of fade-out (match CSS)
    }, 5000); // Switch every 5 seconds (adjustable)
  
    return () => clearInterval(interval);
  }, []);
  

  const current = data[index];

  return (
    <Card className="card-one p-2">
      <div className={`d-flex align-items-center fade-wrapper ${fade ? 'fade-in' : 'fade-out'}`}>
        <i className={`${current.icon} fs-48 lh-1 me-3 ${current.color}`}></i>
        <div>
          <h6 className="fw-semibold text-dark mb-1">{current.title}</h6>
          <p className="fs-sm text-secondary mb-0">{current.description}</p>
        </div>
      </div>
    </Card>
  );
};

export default Updates;
